import { render, staticRenderFns } from "./FullWidthBanner.vue?vue&type=template&id=a9048ce2&scoped=true&lang=pug&"
import script from "./FullWidthBanner.vue?vue&type=script&lang=js&"
export * from "./FullWidthBanner.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthBanner.vue?vue&type=style&index=0&id=a9048ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9048ce2",
  null
  
)

export default component.exports